import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-shortform',
    templateUrl: './shortform.component.html',
    styleUrls: ['./shortform.component.css'],
    standalone: false
})
export class ShortformComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
